// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refresh-enterprise-users {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding-bottom: 2rem;
}

/* Tab styling */
.refresh-enterprise-users .nav-tabs {
  border-bottom: none;
  display: flex !important;
  gap: 0.5rem;
}

.refresh-enterprise-users .nav-tabs .nav-item {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Inactive tab - solid light background with dark text for visibility */
.refresh-enterprise-users .nav-tabs .nav-link {
  color: #2d3748 !important;
  border-radius: 8px 8px 0 0;
  padding: 0.75rem 1.5rem;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.7) !important;
  font-size: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  border-bottom: none !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.refresh-enterprise-users .nav-tabs .nav-link strong {
  font-size: 1.1rem;
}

.refresh-enterprise-users .nav-tabs .nav-link:hover {
  color: #2d3748 !important;
  background: rgba(255, 255, 255, 0.85) !important;
  border-color: white !important;
}

/* Active tab - solid white background */
.refresh-enterprise-users .nav-tabs .nav-link.active {
  color: #2d3748 !important;
  background: white !important;
  border: 2px solid white !important;
  border-bottom: none !important;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

.refresh-enterprise-users .container-fluid {
  max-width: 100%;
}

.refresh-enterprise-users .card {
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
}

.refresh-enterprise-users .card-header {
  border-radius: 12px 12px 0 0 !important;
  padding: 0.75rem 1rem;
  font-weight: 600;
}

/* Vertical stat cards for left panel */
.refresh-enterprise-users .stat-card-vertical {
  background: white;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.refresh-enterprise-users .stat-card-vertical:hover {
  background: #f0f4ff;
  transform: translateX(3px);
}

.refresh-enterprise-users .stat-card-vertical.active {
  background: #e3f2fd;
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

.refresh-enterprise-users .stat-icon-sm {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: white;
  flex-shrink: 0;
}

.refresh-enterprise-users .stat-info {
  flex: 1 1;
  min-width: 0;
}

.refresh-enterprise-users .stat-value-sm {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1.2;
}

.refresh-enterprise-users .stat-label-sm {
  font-size: 0.7rem;
  color: #718096;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Header styling */
.refresh-enterprise-users h4 {
  color: #2d3748 !important;
  font-weight: 700;
  margin: 0;
}

.refresh-enterprise-users h5 {
  color: white;
  font-weight: 600;
}

.refresh-enterprise-users h6 {
  font-weight: 600;
}

/* Table styling */
.refresh-enterprise-users .table {
  margin-bottom: 0;
}

.refresh-enterprise-users .table thead th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
}

.refresh-enterprise-users .table tbody td {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
  font-size: 0.85rem;
}

.refresh-enterprise-users .table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

/* Badge styling */
.refresh-enterprise-users .badge {
  padding: 0.35rem 0.5rem;
  font-weight: 600;
  font-size: 0.75rem;
}

/* Button styling */
.refresh-enterprise-users .btn {
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.refresh-enterprise-users .btn-sm {
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
}

.refresh-enterprise-users .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Alert styling */
.refresh-enterprise-users .alert {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Spinner */
.refresh-enterprise-users .spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Pagination styling */
.refresh-enterprise-users .pagination .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

/* Card footer */
.refresh-enterprise-users .card-footer {
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .refresh-enterprise-users .stat-card-vertical {
    padding: 0.75rem 1rem;
  }

  .refresh-enterprise-users .stat-value-sm {
    font-size: 1.25rem;
  }

  .refresh-enterprise-users .stat-label-sm {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .refresh-enterprise-users .d-flex.gap-2 {
    flex-direction: column;
  }

  .refresh-enterprise-users .d-flex.gap-2 .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RefreshEnterpriseUsers.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,+CAA+C;EAC/C,eAAe;EACf,qDAAqD;EACrD,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".refresh-enterprise-users {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding-bottom: 2rem;\n}\n\n/* Tab styling */\n.refresh-enterprise-users .nav-tabs {\n  border-bottom: none;\n  display: flex !important;\n  gap: 0.5rem;\n}\n\n.refresh-enterprise-users .nav-tabs .nav-item {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Inactive tab - solid light background with dark text for visibility */\n.refresh-enterprise-users .nav-tabs .nav-link {\n  color: #2d3748 !important;\n  border-radius: 8px 8px 0 0;\n  padding: 0.75rem 1.5rem;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.7) !important;\n  font-size: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.8) !important;\n  border-bottom: none !important;\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.refresh-enterprise-users .nav-tabs .nav-link strong {\n  font-size: 1.1rem;\n}\n\n.refresh-enterprise-users .nav-tabs .nav-link:hover {\n  color: #2d3748 !important;\n  background: rgba(255, 255, 255, 0.85) !important;\n  border-color: white !important;\n}\n\n/* Active tab - solid white background */\n.refresh-enterprise-users .nav-tabs .nav-link.active {\n  color: #2d3748 !important;\n  background: white !important;\n  border: 2px solid white !important;\n  border-bottom: none !important;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.refresh-enterprise-users .container-fluid {\n  max-width: 100%;\n}\n\n.refresh-enterprise-users .card {\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n.refresh-enterprise-users .card-header {\n  border-radius: 12px 12px 0 0 !important;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n}\n\n/* Vertical stat cards for left panel */\n.refresh-enterprise-users .stat-card-vertical {\n  background: white;\n  border-radius: 8px;\n  padding: 0.5rem 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.refresh-enterprise-users .stat-card-vertical:hover {\n  background: #f0f4ff;\n  transform: translateX(3px);\n}\n\n.refresh-enterprise-users .stat-card-vertical.active {\n  background: #e3f2fd;\n  border-color: #2196f3;\n  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);\n}\n\n.refresh-enterprise-users .stat-icon-sm {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  color: white;\n  flex-shrink: 0;\n}\n\n.refresh-enterprise-users .stat-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.refresh-enterprise-users .stat-value-sm {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #2d3748;\n  line-height: 1.2;\n}\n\n.refresh-enterprise-users .stat-label-sm {\n  font-size: 0.7rem;\n  color: #718096;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Header styling */\n.refresh-enterprise-users h4 {\n  color: #2d3748 !important;\n  font-weight: 700;\n  margin: 0;\n}\n\n.refresh-enterprise-users h5 {\n  color: white;\n  font-weight: 600;\n}\n\n.refresh-enterprise-users h6 {\n  font-weight: 600;\n}\n\n/* Table styling */\n.refresh-enterprise-users .table {\n  margin-bottom: 0;\n}\n\n.refresh-enterprise-users .table thead th {\n  background: #f8f9fa;\n  color: #495057;\n  font-weight: 600;\n  border-bottom: 2px solid #dee2e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n.refresh-enterprise-users .table tbody td {\n  padding: 0.5rem 0.75rem;\n  vertical-align: middle;\n  font-size: 0.85rem;\n}\n\n.refresh-enterprise-users .table-hover tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n/* Badge styling */\n.refresh-enterprise-users .badge {\n  padding: 0.35rem 0.5rem;\n  font-weight: 600;\n  font-size: 0.75rem;\n}\n\n/* Button styling */\n.refresh-enterprise-users .btn {\n  border-radius: 6px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.refresh-enterprise-users .btn-sm {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n.refresh-enterprise-users .btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n/* Alert styling */\n.refresh-enterprise-users .alert {\n  border-radius: 8px;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Spinner */\n.refresh-enterprise-users .spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n/* Pagination styling */\n.refresh-enterprise-users .pagination .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8rem;\n}\n\n/* Card footer */\n.refresh-enterprise-users .card-footer {\n  background: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n}\n\n/* Responsive adjustments */\n@media (max-width: 991px) {\n  .refresh-enterprise-users .stat-card-vertical {\n    padding: 0.75rem 1rem;\n  }\n\n  .refresh-enterprise-users .stat-value-sm {\n    font-size: 1.25rem;\n  }\n\n  .refresh-enterprise-users .stat-label-sm {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .refresh-enterprise-users .d-flex.gap-2 {\n    flex-direction: column;\n  }\n\n  .refresh-enterprise-users .d-flex.gap-2 .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
